import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  EmailValidatorComponent,
  PhoneValidatorComponent,
  TextFieldsComponent,
} from '@loup-transload-ui-app/common-components';

@Component({
  selector: 'app-contact-info-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextFieldsComponent,
    PhoneValidatorComponent,
    EmailValidatorComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './contact-info-form.component.html',
  styleUrl: './contact-info-form.component.scss',
})
export class ContactInfoFormComponent {
  @Input() formGroup!: FormGroup;
  @Input() isSubmitted = false;
  @Output() next = new EventEmitter<void>();
  @Output() resetAction = new EventEmitter<void>();
  public imageTruck = 'assets/images/contact-form.svg';
  public isRequired = ' is required.';
  public companyName = 'Company Name';
  public contactName = 'Contact Name';
  public phoneNumber = 'Phone Number';
  public emailAddress = 'E-Mail Address';

  fieldValue(event, fieldName) {
    this.formGroup.get(fieldName)?.setValue(event);
    this.formGroup.get(fieldName)?.markAsTouched();
  }

  onClickNext() {
    this.isSubmitted = true;
    this.formGroup.markAllAsTouched(); 
    if (!this.formGroup.valid) {
      return; 
    }
    this.next.emit();
  }
}
